import SectionBlockRender from '../../components/SectionBlockRender'
import PageContent from '../PageContent'

export default function PageBase({ path }: { path: string }) {
    return <PageContent path={path}>{({ data }) => <SectionBlockRender sections={data.sections} />}</PageContent>
}
